// import { useDebugValue } from "react";
import { useSelector } from "react-redux";
import { selectCurrentUser, selectCurrentToken, selectCurrentPersist } from "context/auth/authSlice";


const useAuth = () => {
    const user    = useSelector(selectCurrentUser);
    const token   = useSelector(selectCurrentToken);
    const persist = useSelector(selectCurrentPersist);

    const authenticate = {
        user,
        persist,
        accessToken :  token
    }
    // useDebugValue(authenticate, auth => auth?.user ? "Logged In" : "Logged Out")
    return authenticate;
}

export default useAuth;